import {createContext} from 'react'

const Storage = createContext({storage:null});

export default Storage;